export const SESSION_TIMEOUT_MS = 24 * 60 * 60 * 1000;

export const DATE_FORMATS = {
  YEAR: 'YYYY',
  MONTH: 'MM',
  DAY: 'DD',
  DATE: 'YYYYMMDD',
  DATETIME: 'YYYY年MM月DD日',
  FULL_DATE: 'YYYY-MM-DD'
};

export const LOADING_CHECK_INTERVAL = 500;

export const NOTIFICATION_AUTO_CLOSE = {
  SUCCESS: 3000,
  ERROR: 5000,
  WARNING: 4000,
  INFO: 3000
};

export const RETRY_CONFIG = {
  MAX_RETRIES: 3,
  DELAY_MS: 1000
};

export const NETWORK_RETRY_DELAY = 1000;

export const BLOCK_SIZE = 100;

// 需要單獨統計的產品系列（供應商：源吉）
// 注意：以前綴比對 pid（startsWith），前綴之間不可互相重疊（如 'C1' 與 'C10' 會被歸入 'C1'）
export const SERIES_STATS_VENDOR = '源吉';
export const PRODUCT_SERIES = ['R5', 'C1'];
